<template>
    <div class='container_wrap'>
        <div class="logo-box">
            <img src="@/assets/images/user/talk/logo.png" alt="">
        </div>
        <div class="center flc" @click="clockIn">
            <img v-if="accept" src="@/assets/images/user/talk/accept-icon.png" alt="">
        </div>
        <div class="address flc">
            <img src="@/assets/images/user/talk/address-clockIn.png" alt="">
            <div>{{TemplateDetail.new_address}}</div>
        </div>
        <div class="agree flc" >
            <div class="check-box flc" @click="changeRead">
                <div v-if="agree" class="check-box-item"></div>
            </div>
            <div @click="readAgree">
                请确认A.O.史密斯用户隐私授权条款
            </div>
        </div>
    </div>
</template>
<script>


import {wxGetLocationH5,getWxSingleConfig} from '@/js/wx.js'

export default {
    name: "",

    // 组件注册
    components: {},
    data() {
        return {
            agree:true,
            accept:false,//是否打卡
            currentArea:{},//用户当前位置
        };
    },
    props: {},
    //计算属性
    computed: {
        TemplateDetail () {
            return this.$store.state.userTalkAppointV3.TemplateDetail
        },
        bDistance() {
            const distance = this.$store.state.userTalkAppointV3.distance
            if (!distance.toString()) return false
            if (distance <= 3000) {
                return true
            } else {
                return false
            }
        },
    },
    // 数据监听
    watch: {},
    //方法集合
    methods: {
        changeRead () {
            this.agree = !this.agree
        },
        // 点击打卡
        clockIn () {
            if (!this.agree) {
                this.$toast('请阅读条款')
                return
            }
            // 如果没获取到地理位置
            if (!this.currentArea.lon) {
                wxGetLocationH5().then (res => {
                    console.log(res,'res');
                    // const location = res.businessAreas[0].location
                    this.$set(this.currentArea,'lat',res.latitude)
                    this.$set(this.currentArea,'lon',res.longitude)
                    this.$store.dispatch({
                        type:'userTalkAppointV3/getDistance2',
                        longitude:res.longitude,
                        latitude:res.latitude,
                        new_longitude:this.TemplateDetail.new_longitude,
                        new_latitude:this.TemplateDetail.new_latitude
                    }).then(() => {
                        console.log(this.bDistance && !this.accept,'this.bDistance && !this.accept')
                        // 如果距离小于1000
                        if (this.bDistance && !this.accept) {
                            console.log(111111)
                            this.accept = true
                            this.$store.dispatch({
                                type:'userTalkAppointV3/getDiscussSign',
                                experience_id:this.project_id,
                                longitude:this.currentArea.lon,
                                latitude:this.currentArea.lat
                            }).then (() => {
                                this.$toast('打卡成功')
                            })
                        }
                        if (!this.bDistance) {
                            this.$toast('当前不在有效范围内，无法签到，请点击右上角刷新页面地理位置或到达指定体验间范围内')
                        }
                        if (this.accept) {
                            this.$toast('您已打卡')
                            return
                        }
                    })
                }).catch (() => {
                    this.$toast({message:'位置获取失败'})
                });
            } else {
                // 获取到了地理位置
                this.$store.dispatch({
                    type:'userTalkAppointV3/getDistance2',
                    longitude:this.currentArea.lon,
                    latitude:this.currentArea.lat,
                    new_longitude:this.TemplateDetail.new_longitude,
                    new_latitude:this.TemplateDetail.new_latitude
                }).then(() => {
                    console.log(this.bDistance && !this.accept,'this.bDistance && !this.accept')
                    // 如果距离小于1000
                    if (this.bDistance && !this.accept) {
                        console.log(22222)
                        this.accept = true
                        this.$store.dispatch({
                            type:'userTalkAppointV3/getDiscussSign',
                            experience_id:this.project_id,
                            longitude:this.currentArea.lon,
                            latitude:this.currentArea.lat
                        }).then (() => {
                            this.$toast('打卡成功')
                        })
                    }
                    if (!this.bDistance) {
                        this.$toast('当前不在有效范围内，无法签到，请点击右上角刷新页面地理位置或到达指定体验间范围内')
                    }
                    if (this.accept) {
                        this.$toast('您已打卡')
                        return
                    }
                })
            }
        },
        readAgree() {
            this.agree = true
            this.$store.dispatch({type: 'userTalkAppointV3/getAgreementData', code: 'discuss_rule'})
            this.$router.push('/user/inviation/agree')
        }
    },
    //生命周期 - 创建完成
    async created() {
        await getWxSingleConfig()
        // setTimeout(() => {
        //     wxGetLocationH5().then (res => {
        //         console.log(res,'res');
        //         // const location = res.businessAreas[0].location
        //         this.$set(this.currentArea,'lat',res.latitude)
        //         this.$set(this.currentArea,'lon',res.longitude)
        //     }).catch (() => {
        //         this.$toast({message:'位置获取失败'})
        //     });
        // },400)
        $init(() => {
            this.project_id = this.$route.query.project_id
            console.log(this.$route.query.project_id,'project_id')
            this.$store.dispatch({type: 'userTalkAppointV3/getTemplateDetail',id:this.project_id})
        })

    },
    //生命周期 - 挂载完成
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.container_wrap {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background-image: url('~@/assets/images/user/talk/background-clockIn.png');
    background-size: 100% 100%;
    .logo-box {
        position: absolute;
        width: 237px;
        height: 29px;
        left: 52px;
        top: 62px;
        img {
            width: 237px;
            height: 29px;
        }
    }
    .center {
        background-image: url('~@/assets/images/user/talk/center-clockIn.png');
        background-size:100% 100%;
        margin: 473px auto 0;
        width:405px;
        height: 405px;
        img {
            width:100px;
            height: 100px;
        }
    }
    .address {
        margin: 83px auto 54px;
        font-size: 35px;
        font-family: FZLTZHUNHK;
        font-weight: normal;
        color: #986F34;
        background: linear-gradient(167deg, #FFF4E3 0%, #B39775 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        img {
            width: 33px;
            height: 42px;
            margin-right: 18px;
        }
        div {
            color: #986F34;
            background: linear-gradient(167deg, #FFF4E3 0%, #B39775 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .agree {
        width: 700px;
        margin: 0 auto;
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        .check-box {
            width: 20px;
            height: 20px;
            border: solid #fff 1px;
            padding:2px;
            border-radius: 50%;
            margin-right: 10px;
            .check-box-item {
                background:#fff;
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
    }
}
::v-deep .van-icon {
    display: flex;
    justify-content:center;
    align-items: center;
}
</style>
